var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPhoneActionEmail1 = function SvgPhoneActionEmail1(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    strokeWidth: 1,
    d: "M9.5 8.5V13.6787C9.5 13.9179 9.45287 14.1548 9.3613 14.3758C9.26972 14.5968 9.13551 14.7976 8.96631 14.9668C8.79711 15.1359 8.59625 15.2701 8.3752 15.3616C8.15415 15.453 7.91724 15.5001 7.678 15.5H3.322C3.08276 15.5001 2.84585 15.453 2.6248 15.3616C2.40375 15.2701 2.20289 15.1359 2.03369 14.9668C1.86449 14.7976 1.73028 14.5968 1.6387 14.3758C1.54713 14.1548 1.5 13.9179 1.5 13.6787V3.322C1.5 2.83878 1.69196 2.37534 2.03365 2.03365C2.37534 1.69196 2.83878 1.5 3.322 1.5H4.5",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.5 12.5H9.5",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.5 1.5V5.5C14.5 5.76522 14.3946 6.01957 14.2071 6.20711C14.0196 6.39464 13.7652 6.5 13.5 6.5H7.5C7.23478 6.5 6.98043 6.39464 6.79289 6.20711C6.60536 6.01957 6.5 5.76522 6.5 5.5V1.5",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.5 1.5C14.5 1.23478 14.3946 0.98043 14.2071 0.792893C14.0196 0.605357 13.7652 0.5 13.5 0.5H7.5C7.23478 0.5 6.98043 0.605357 6.79289 0.792893C6.60536 0.98043 6.5 1.23478 6.5 1.5L9.97 3.66667C10.1289 3.766 10.3126 3.81867 10.5 3.81867C10.6874 3.81867 10.8711 3.766 11.03 3.66667L14.5 1.5Z",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPhoneActionEmail1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "phone-action-email1.ed6bf0712133697e66df07969cfa46fa.svg";